import { ReactNode } from "react";
import { AgentPage } from "@/types/agent/agent-page";
import HeroTemplate from "./HeroTemplate";
import SalesTemplate from "./SalesTemplate";
import SupportTemplate from "./SupportTemplate";

export type PageTemplate = "hero" | "sales" | "support" | null;

interface TemplateWrapperProps {
  template: PageTemplate;
  agent: AgentPage;
  children: ReactNode;
}

// TODO replace

const TemplateWrapper = ({ template, agent, children }: TemplateWrapperProps) => {
  // If no template selected, render children directly (default behavior)
  if (!template) {
    return <>{children}</>;
  }

  // Route to appropriate template
  switch (template) {
    case "hero":
      return <HeroTemplate agent={agent}>{children}</HeroTemplate>;
    case "sales":
      return <SalesTemplate agent={agent}>{children}</SalesTemplate>;
    case "support":
      return <SupportTemplate agent={agent}>{children}</SupportTemplate>;
    default:
      return <>{children}</>;
  }
};

export default TemplateWrapper;
